import { DesktopScrollableTable } from './desktop/DesktopScrollableTable';
import { MobileScrollableTable } from './mobile/MobileScrollableTable';

export const ScrollableTable = ({ screen, ...props }) => {
  const isMobileScreen = screen === 'mobile';

  return isMobileScreen ? <MobileScrollableTable {...props} /> : <DesktopScrollableTable {...props} />;
};
